
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/support/Terms/[id]",
      function () {
        return require("private-next-pages/support/Terms/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/support/Terms/[id]"])
      });
    }
  